// MUI Imports
// import { ReactComponent as CollapseIcon } from '~/svgs/collapse-open.svg'
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var iconStyles = function (theme) { return ({
    userSelect: 'none',
    display: 'inline-block',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
    }),
    paddingTop: '0.5px',
    fontSize: '1.25rem',
    position: 'absolute',
    right: '0.85rem',
    pointerEvents: 'none'
}); };
var select = {
    MuiSelect: {
        defaultProps: {
            // IconComponent: () => <CollapseIcon />,
            size: 'medium'
        },
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return ({
                    '&.MuiInputBase-root': {
                        height: '2.5rem'
                    },
                    '& .MuiSelect-select': {
                        padding: theme.spacing(1, 1.75)
                    }
                });
            },
            select: function (_a) {
                var theme = _a.theme, ownerState = _a.ownerState;
                return (__assign(__assign(__assign({}, (ownerState.variant === 'outlined' && {
                    minHeight: 'var(--mui-shape-height-inputForm)'
                })), (ownerState.variant === 'filled' && {
                    boxShadow: '0px 4px 14px 0px #0000001A',
                    borderRadius: 'var(--mui-shape-customBorderRadius-lg)',
                    backgroundColor: '#FFFFFF',
                    minHeight: 'var(--mui-shape-height-inputForm)'
                })), { '&[aria-expanded="true"] ~ i, &3[aria-expanded="true"] ~ svg': {
                        transform: 'rotate(180deg)'
                    }, '& ~ i, & ~ svg': iconStyles(theme), '&.MuiInputBase-inputSizeSmall': {
                        '& ~ i, & ~ svg': {
                            height: '1.375rem',
                            width: '1.375rem'
                        }
                    }, '&:not(aria-label="Without label") ~ .MuiOutlinedInput-notchedOutline > legend > span': {
                        paddingInline: '5px'
                    } }));
            }
        }
    },
    MuiNativeSelect: {
        styleOverrides: {
            select: function (_a) {
                var theme = _a.theme;
                return ({
                    '& + i, & + svg': iconStyles(theme)
                });
            }
        }
    }
};
export default select;
